import { getDefaultStore } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const oauthCallbackDateAtom = atomWithStorage<number>(
  "oauthCallbackDate",
  0
);

export const isInOauthFlow = () => {
  const store = getDefaultStore();
  const oauthCallbackDate = store.get(oauthCallbackDateAtom);
  return Date.now() - oauthCallbackDate < 1000 * 60 * 30;
};

const OAUTH_ALLOWED_PATH_PREFIXES = [
  "/scan",
  "/verify-failed",
  "/verify-go-back",
  "/verify-success",
  "/verify-registration-success",
  "/result",
];

export const isOauthAllowedPath = (pathname: string) =>
  OAUTH_ALLOWED_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix + "/")
  );
